import React, { useState } from "react";
import { submitContactForm } from "../api";
import SEO from './SEO';
import 'bootstrap/dist/css/bootstrap.min.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    message: "",
  });
  const [success, setSuccess] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitContactForm(formData);
      setSuccess(true);
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting contact form", error);
    }
  };

  return (
    <>
      <SEO 
        title="Contact Gators Transportation | Get In Touch for Transportation Services"
        description="Contact Gators Transportation for all your luxury transportation needs in Jacksonville. Get quotes, ask questions, and book your transportation service today."
        keywords="contact Jacksonville transportation, get transportation quote, Gators Transportation contact, luxury transportation inquiry"
        canonical="/contact"
      />
      <section className="py-5" style={{background:'#f8f9fa', width:'100vw', margin:0, padding:0, overflowX:'hidden'}}>
        <div className="container-fluid">
          <div className="row justify-content-center align-items-stretch">
            {/* Location Section */}
            <div className="col-lg-6 mb-4 d-flex">
              <div className="card shadow-lg border-0 h-100 w-100" style={{borderRadius:'2rem', background:'#fff', boxShadow:'0 8px 32px 0 rgba(31,38,135,0.12)', padding:'2rem'}}>
                <h3 className="mb-4 text-center">📍 Our Location</h3>
                
                <div className="mb-4">
                  <div className="row mb-3">
                    <div className="col-sm-3"><strong>Address:</strong></div>
                    <div className="col-sm-9">2800 North Poinciana Blvd, Kissimmee, FL</div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3"><strong>Phone:</strong></div>
                    <div className="col-sm-9">
                      <a href="tel:4075013333" className="text-decoration-none">(407) 501-3333</a>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3"><strong>Email:</strong></div>
                    <div className="col-sm-9">
                      <a href="mailto:Gatorstransport87@gmail.com" className="text-decoration-none">Gatorstransport87@gmail.com</a>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3"><strong>Follow Us:</strong></div>
                    <div className="col-sm-9">
                      <a href="https://facebook.com" target="_blank" rel="noreferrer" className="me-3">
                        <img src="/images/facebook.ico" alt="Facebook" style={{width:24,height:24}} />
                      </a>
                      <a href="https://instagram.com" target="_blank" rel="noreferrer">
                        <img src="/images/insta.ico" alt="Instagram" style={{width:24,height:24}} />
                      </a>
                    </div>
                  </div>
                </div>
                
                <div className="map-container" style={{borderRadius:'1rem', overflow:'hidden'}}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3522.2856446!2d-81.4064!3d28.3094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dd7b3b6b6b6b6b%3A0x6b6b6b6b6b6b6b6b!2s2800%20N%20Poinciana%20Blvd%2C%20Kissimmee%2C%20FL%2034746!5e0!3m2!1sen!2sus!4v1234567890123"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Gators Transportation Location"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Contact Form Section */}
            <div className="col-lg-6 mb-4 d-flex">
              <div className="card shadow-lg border-0 h-100 w-100" style={{borderRadius:'2rem', background:'#fff', boxShadow:'0 8px 32px 0 rgba(31,38,135,0.12)', padding:'2rem'}}>
                <h3 className="mb-4 text-center">💬 Contact Us</h3>
                
                {success && (
                  <div className="alert alert-success" role="alert">
                    Message sent successfully! We'll get back to you soon.
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleChange}
                        placeholder="First Name"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleChange}
                        placeholder="Last Name"
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email Address"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      name="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your transportation needs..."
                      required
                    ></textarea>
                  </div>

                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary">
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;
